export const MANUAL_PROMISE_REJECTION = new Error('Promise manual rejection');

export class RejectablePromise<T> extends Promise<T> {
    constructor(
        executor: (
            resolve: (value: T | PromiseLike<T>) => void,
            reject: (reason?: any) => void,
        ) => void,
    ) {
        let rejectFunc = (): void => {};

        super((resolve, reject) => {
            rejectFunc = () => {
                reject(MANUAL_PROMISE_REJECTION);
            };
            executor(resolve, reject);
        });

        this.reject = rejectFunc;
    }

    static wrap<T>(promise: Promise<T>): RejectablePromise<T> {
        return new RejectablePromise<T>((resolve, reject) => {
            promise.then(resolve).catch(reject);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    reject(): void {}
}
